var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { t } from 'i18next';
import ModalComponent from '@molecules/BEOffScreen/Modal';
import { ExternalPaymentMessage } from '@view/components/Payment/ExternalPaymentMessage';
import { Flex, Text } from '@chakra-ui/react';
import Button from '@molecules/Button';
import { processNextActionRedirect } from '@business/utils/payment-next-action';
export const ModalPaymentInProgress = (_a) => {
    var { popupWindow, nextAction, onOpenExternalWindow, onErrorOpeningWindow, target, windowFeatures } = _a, modalProps = __rest(_a, ["popupWindow", "nextAction", "onOpenExternalWindow", "onErrorOpeningWindow", "target", "windowFeatures"]);
    // A nextAction means the payment needs verification (3DS); the redirect opens
    // from the user's click to avoid the pop-up blocker.
    const requiresVerification = !!nextAction;
    const interactable = !!popupWindow || requiresVerification;
    const handleClickContinue = () => {
        if (nextAction) {
            processNextActionRedirect({
                nextAction,
                onErrorOpeningWindow,
                onOpenExternalWindow,
                target,
                windowFeatures,
            });
            return;
        }
        popupWindow === null || popupWindow === void 0 ? void 0 : popupWindow.focus();
    };
    return (_jsx(ModalComponent, Object.assign({}, modalProps, { 
        // Not dismissible while verification is required, so the guest completes 3DS.
        closable: !requiresVerification && interactable, hideFooter: true, maskClosable: false, children: _jsx(Flex, { alignItems: "center", direction: "column", mb: 6, children: requiresVerification ? (_jsxs(Flex, { alignItems: "center", direction: "column", gap: 4, py: 4, children: [_jsx(Text, { textAlign: "center", children: t('payments/payment-verification-required') }), _jsx(Button, { color: "primary", onClick: handleClickContinue, children: t('payments/verify-payment') })] })) : (_jsxs(_Fragment, { children: [_jsx(ExternalPaymentMessage, {}), interactable && (_jsx(Button, { color: "primary", onClick: handleClickContinue, variant: "link", children: t('click-to-continue') }))] })) }) })));
};
